import { UserMatchRatingButtons } from '@src/components/sco/Matching/UserMatchRatingButtons'
import { gql } from '@src/lib/gql'

export const USER_MATCH_FRAGMENT = gql`
  fragment _ on ScoUserMatch {
    id
    userMatchId
    matchExplanation
    matchScore
    matchScoreAsPercent
    matchFactors
    targetUser {
      id
      userId
      firstName
      lastName
      lastActiveAt
      fullName
      pictureUrl
      isAdvisor
      isToolUser
      slug
      bio
      shortBio
      linkedin
      twitter
      location
      company {
        id
        name
        elevatorPitch
        url
        logoUrl
        location
      }
      userSkills {
        id
        userSkillId
        experienceNotes
        experienceStrength
        skill {
          id
          title
        }
      }
      skills {
        id
        title
      }
    }
    ${UserMatchRatingButtons.fragments.ScoUserMatch()}
  }
`

export const USER_SEARCH_SUBSCRIPTION_FRAGMENT = gql`
  fragment _ on ScoUserSearch {
    id
    userSearchId
    title
    skills {
      id
      skillId
      title
    }
    relevantSkills
    requiredSkills
    industryKeys
    parametersAsJSON
    location
    locationState
    locationCity
    locationState
    locationLatitude
    locationLongitude
    naturalLanguagePrompt
    processingDescription
    processingStatus
    processingUpdatedAt
    userMatches(page: 1, pageSize: 50, order: [["matchScore", "desc"]]) {
      id
      pagination {
        itemCount
      }
      items {
        id
        userMatchId
        matchScore
        targetUser {
          id
          fullName
          pictureUrl
        }
      }
    }
  }
`

export const USER_SEARCH_FRAGMENT = gql`
  fragment _ on ScoUserSearch {
    id
    userSearchId
    title
    skillIds
    skills {
      id
      skillId
      title
    }
    updatedAt
    createdAt
    relevantSkills
    requiredSkills
    industryKeys
    isMatchEmailEnabled
    parametersAsJSON
    location
    locationState
    locationCity
    locationState
    locationLatitude
    locationLongitude
    naturalLanguagePrompt
    processingDescription
    processingStatus
    processingUpdatedAt
    userMatches(page: 1, pageSize: 50, order: [["matchScore", "desc"]]) {
      id
      pagination {
        itemCount
      }
      items {
        id
        userMatchId
        matchScore
        targetUser {
          id
          fullName
          pictureUrl
        }
      }
    }
  }
`
